import { useDebounce } from "usehooks-ts";
import { useShipmentFiltersContext } from "../context/ShipmentFiltersContext";
import type { ShipmentFiltersSnapshot } from "../utils/makeShipmentFilterVariables";

const SEARCH_DEBOUNCE_MS = 700;

export function useShipmentFilterSnapshot(): ShipmentFiltersSnapshot {
  const {
    searchTerm,
    trackingNumbersFilter,
    displayIdsFilter,
    orderNameSearch,
    selectedDriverLabelIds,
    selectedOrderLabelIds,
    selectedEndCustomerLabelIds,
    selectedCourierBrandIds,
    selectedAcquisitionTypes,
    selectedRecurrenceTypes,
    selectedPickupZoneIds,
    selectedDropoffZoneIds,
    selectedPackageTypeIds,
    selectedOrderVehicleTypeIds,
    selectedDriverVehicleTypeIds,
    selectedServiceTypeIds,
    minWeightInPounds,
    maxWeightInPounds,
    selectedRouteTemplateIds,
    hasOrderInternalNote,
    hasDriverNoteOnly,
    hasWaitTimeOrOverride,
    hasMultipleDriverPayOnly,
    hasUnapprovedDriverPackageReportOnly,
    isLate,
    isOnTime,
    isAttempted,
  } = useShipmentFiltersContext();

  const debouncedSearchTerm = useDebounce(searchTerm, SEARCH_DEBOUNCE_MS);

  return {
    debouncedSearchTerm,
    trackingNumbersFilter,
    displayIdsFilter,
    orderNameSearch,
    selectedDriverLabelIds,
    selectedOrderLabelIds,
    selectedEndCustomerLabelIds,
    selectedCourierBrandIds,
    selectedAcquisitionTypes,
    selectedRecurrenceTypes,
    selectedPickupZoneIds,
    selectedDropoffZoneIds,
    selectedPackageTypeIds,
    selectedOrderVehicleTypeIds,
    selectedDriverVehicleTypeIds,
    selectedServiceTypeIds,
    minWeightInPounds,
    maxWeightInPounds,
    selectedRouteTemplateIds,
    hasOrderInternalNote,
    hasDriverNoteOnly,
    hasWaitTimeOrOverride,
    hasMultipleDriverPayOnly,
    hasUnapprovedDriverPackageReportOnly,
    isLate,
    isOnTime,
    isAttempted,
  };
}
